// import { arrayMove } from "redux-form";
import { arrayMove } from "react-sortable-hoc";
import React, { Children, PureComponent } from "react";

import SortableReduxForm from "./SortableReduxForm";

class SortableList extends PureComponent {
  state = {
    items: Children.toArray(this.props.children)
  };

  handleSubmit = values => {
    const orderedValues = this.state.items.reduce(
      (p, { props: { name } }) => (
        // eslint-disable-next-line no-sequences
        (p[name] = values[name] !== undefined ? values[name] : ""), p
      ),
      {}
    );
    //values.fieldOrder = this.state.items.map(({ props: { name } }) => name)
    this.props.onSubmit(orderedValues);
  };

  onSortEnd = ({ oldIndex, newIndex, collection }, e) => {
    console.log(collection, e, oldIndex, newIndex);
    this.setState({
      // items: arrayMove("sortableForm", this.state.items, oldIndex, newIndex)
      items: arrayMove(this.state.items, oldIndex, newIndex)
    });
  };
  render() {
    return (
      <SortableReduxForm
        initialValues={this.props.initialValues}
        onSubmit={this.handleSubmit}
        items={this.state.items}
        onSortEnd={this.onSortEnd}
        lockAxis="y"
        lockToContainerEdges
        lockOffset={["0%", "100%"]}
        useDragHandle
      />
    );
  }
}

export default SortableList;



// WEBPACK FOOTER //
// ./src/components/profile/SortableForm/SortableList.js